import { freeze } from 'immer';
import { SideNavItem } from 'src/app/shell/side-navigation/side-nav/side-nav-item.model';

const MENU_ITEMS: SideNavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'dashboard',
    viewName: 'DASHBOARD',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'dashboard'],
  },
  {
    id: 'review-deprecated', // TODO: Delete this item when the old review page is removed
    label: 'Old Review',
    icon: 'task',
    viewName: 'TRANSMITTAL_REVIEW_TASK_LIST',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'review-deprecated'],
    featureFlagKey: 'OldReviewPage',
  },
  {
    id: 'review',
    label: 'Review',
    icon: 'task',
    viewName: 'TRANSMITTAL_REVIEW_TASK_LIST',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'review'],
  },
  {
    id: 'deliverables_overview',
    label: 'Deliverables Status',
    icon: 'notebook',
    viewName: 'DELIVERABLES_OVERVIEW',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'deliverables-status'],
  },
  {
    id: 'deliverables_admin',
    label: 'Deliverables Admin',
    icon: 'book',
    viewName: 'DELIVERABLES_ADMIN',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'deliverables'],
  },
  {
    id: 'package_responsibility_matrix',
    label: 'PRM',
    icon: 'flow',
    viewName: 'PACKAGE_RESPONSIBILITY_MATRIX',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'prm'],
  },
  {
    id: 'distribution',
    label: 'Subscription Matrix',
    icon: 'scatter-matrix',
    viewName: 'DISTRIBUTION',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'distribution-matrix'],
  },
  {
    id: 'tag_admin',
    label: 'Tag administration',
    icon: 'tag',
    viewName: 'TAG_ADMIN',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'tagadministration'],
  },
  {
    id: 'project_setup',
    label: 'Project setup',
    icon: 'settings',
    viewName: 'PROJECT_SETUP',
    children: [
      {
        id: 'basic_setup',
        label: 'Basic setup',
        children: [
          {
            id: 'responsible_discipline_setup',
            label: 'Disciplines',
            viewName: 'RESPONSIBLE_DISCIPLINE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'responsiblediscipline'],
          },
          {
            id: 'propertydef_setup',
            label: 'Property def.',
            viewName: 'PROPERTYDEF_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'propertydefinitions'],
          },
          {
            id: 'index_and_classification_setup',
            label: 'Index & Classification',
            viewName: 'INDEX_AND_CLASSIFICATION_SETUP',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'index_and_classification'],
          },
          {
            id: 'classification_setup',
            label: 'Classifications',
            viewName: 'CLASSIFICATION_SETUP',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'setupclassifications'],
            featureFlagKey: 'ProjectBasicSetupClassifications',
          },
          {
            id: 'index_definition_setup',
            label: 'Index definitions',
            viewName: 'INDEX_DEFINITION_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'index'],
            featureFlagKey: 'ProjectBasicSetupIndexDefinitions',
          },
          {
            id: 'reason_for_issue_setup',
            label: 'Reason for issue',
            viewName: 'REASON_FOR_ISSUE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'reasonforissue'],
          },
          {
            id: 'return_code_setup',
            label: 'Return codes',
            viewName: 'RETURN_CODE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'statuscodes'],
          },
          {
            id: 'package_setup',
            label: 'Packages',
            viewName: 'PACKAGE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'setuppackages'],
          },
          {
            id: 'code_table_setup',
            label: 'Code tables',
            viewName: 'CODE_TABLE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'codetables'],
          },
          {
            id: 'project_parameter_setup',
            label: 'Parameters',
            viewName: 'PROJECT_PARAMETER_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'parameters'],
          },
          {
            id: 'deliverable_type_setup',
            label: 'Deliverable types',
            viewName: 'DELIVERABLE_TYPE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'setupdeliverables'],
          },
          {
            id: 'terminology_setup',
            label: 'Terminology',
            viewName: 'TERMINOLOGY_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'terminology'],
            featureFlagKey: 'Terminology',
          },
        ],
      },
      {
        id: 'labeling',
        label: 'Labeling',
        children: [
          {
            id: 'labeling_rule_property_set_setup',
            label: 'Property set',
            viewName: 'LABELING_RULE_PROPERTY_SET_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'propertyset'],
          },
          {
            id: 'labeling_rule_setup',
            label: 'Rules',
            viewName: 'LABELING_RULE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'rules'],
          },
          {
            id: 'function_code_setup',
            label: 'Function codes',
            viewName: 'FUNCTION_CODE_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'functioncodes'],
          },
        ],
      },
      {
        id: 'view_setup',
        label: 'View setup',
        children: [
          {
            id: 'general_view_setup',
            label: 'General views',
            viewName: 'GENERAL_VIEW_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'generalviews'],
          },
          {
            id: 'class_view_setup',
            label: 'Class views',
            viewName: 'CLASS_VIEW_SETUP',
            routerLink: '/',
            url: ['', 'projects', '{projectId}', 'projectsetup', 'classviews'],
          },
        ],
      },
    ],
  },
  {
    id: 'project_create',
    label: 'Projects',
    icon: 'portfolio',
    viewName: 'PROJECT_CREATE',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'projectlist'],
  },
  {
    id: 'user_setup',
    label: 'User setup',
    icon: 'user--multiple',
    viewName: 'USER_SETUP',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'usersetup'],
  },
  {
    id: 'tenant_setup',
    label: 'Tenant setup',
    icon: 'settings',
    viewName: 'TENANT_SETUP',
    children: [
      {
        id: 'units_setup',
        label: 'Units',
        viewName: 'UNITS_SETUP',
        routerLink: '/',
        url: ['', 'projects', '{projectId}', 'units'],
      },
    ],
  },
  {
    id: 'transmittals',
    label: 'Transmittals',
    icon: 'send',
    viewName: 'TRANSMITTALS',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'transmittals'],
  },
  {
    id: 'sidrl',
    label: 'SIDRL',
    icon: 'table',
    viewName: 'SIDRL',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'sidrl'],
    featureFlagKey: 'SIDRL',
  },
  {
    id: 'transactions-monitor',
    label: 'Transactions monitor',
    icon: 'data--view',
    viewName: 'CDF_OPERATION',
    routerLink: '/',
    url: ['', 'projects', '{projectId}', 'transactions-monitor'],
  },
  {
    id: 'batch-download',
    label: 'Batch download',
    icon: 'document--download',
    viewName: 'FILE_BATCH_EXPORT',
    routerLink: '/',
    featureFlagKey: 'BatchDownload',
    url: ['', 'projects', '{projectId}', 'batch-download'],
  },
];

export const frozenMenuItems = freeze(MENU_ITEMS, true);
